import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import Loader from '../spinner';
import css from './index.scss';
import TeacherDetail from '../../components/teacher-details/index';
import TeacherClassDetail from '../../components/teacher-class-detail/index';
import Button from '../button/index';
import { DARK } from '../button/variants';
import messages from './messages';
import { invalidCharaters, invalidEmailCharaters, isValidEmail, validatePassword } from '../../helpers/utils';
import Modal from '../modal';
import Authentication from '../authentication';

class EditTeacherForm extends Component {
    constructor(props) {
        super(props);
        this.state = { canSubmit: false, isDirty: false, showAuthenticationModal: false, adminPassword: '' };
        this.handleTextInputOnChange = this.handleTextInputOnChange.bind(this);
        this.handleEmailInputOnChange = this.handleEmailInputOnChange.bind(this);
        this.props.teacherTitles[0].value = this.props.intl.formatMessage(messages.teacherTitleNone);
        this.props.teacherTitles[0].key = this.props.intl.formatMessage(messages.teacherTitleNone_key);
    }

    validateTeacherModel = (isDirty) => {
        let canSubmit = false;
        if (this.props.teacher.firstName.trim() !== '' &&
            this.props.teacher.lastName.trim() !== '') {
            canSubmit = true;
        }

        this.setState({ canSubmit, isDirty });
    }

    handleTextInputOnChange = (event) => {
        const regex = new RegExp(invalidCharaters());
        const value = event.target.value;
        const field = event.target.name;
        if (value !== '' && !regex.test(value)) {
            event.preventDefault();
            return false;
        }

        this.props.teacher[field] = value;
        this.validateTeacherModel(true);
        return true;
    }


    handleEmailInputOnChange = (event) => {
        const regex = new RegExp(invalidEmailCharaters());
        const value = event.target.value;
        const field = event.target.name;
        if (value !== '' && !regex.test(value)) {
            event.preventDefault();
            return false;
        }

        this.props.teacher[field] = value;
        this.validateTeacherModel(true);
        return true;
    }

    handleListOnChange = (field, value) => {
        this.props.teacher[field] = value;
        this.validateTeacherModel(true);
    }

    handleOnPasswordInputChange = (event) => {
        const { teacher } = this.props;
        const value = event.target.value;
        const field = event.target.name;
        teacher[field] = value;
        this.setState({ canSubmit: true });
    }

    handleOnSubmit = () => {
        const { teacher } = this.props;
        const regex = new RegExp(validatePassword());
        let isValid = true;
        const MAX_PASSWORD_LENGTH = 8;

        if (teacher.emailAddress !== '' && isValidEmail(teacher.emailAddress)) {
            if (teacher.isResetTeacherpassword) {
                if (!teacher.newPassword || !teacher.confirmationPassword) {
                    this.props.showToast(this.props.intl.formatMessage(messages.passwordValidationMessage4), 'error');
                    isValid = false;
                } else if (teacher.newPassword !== '' && teacher.confirmationPassword !== '') {
                    if (teacher.newPassword !== teacher.confirmationPassword) {
                        this.props.showToast(this.props.intl.formatMessage(messages.passwordValidationMessage2), 'error');
                        isValid = false;
                    } else {
                        [teacher.newPassword, teacher.confirmationPassword].forEach((password) => {
                            if (!regex.test(password) || password.length < MAX_PASSWORD_LENGTH) {
                                this.props.showToast(this.props.intl.formatMessage(messages.passwordValidationMessage1), 'error');
                                isValid = false;
                            }
                        });
                    }
                }
            }
        } else {
            this.props.showToast(this.props.intl.formatMessage(messages.emailRequiredMessage), 'error');
            isValid = false;
        }

        if (isValid) {
            // Temporarily commenting below line to disable reauthentication (Req : COY-4285)
            // this.setState({ showAuthenticationModal: true });
            this.saveChanges();
        } else {
            this.setState({ canSubmit: true });
        }
    }

    saveChanges = () => {
        this.setState({ canSubmit: false });
        this.props.handleOnEditTeacherSubmit();
    }

    handleOnCloseValidationModal = () => {
        this.setState({ canSubmit: true });
        this.props.closeEditTeacherValidationModal();
    }

    resetPassword = (status) => {
        const { teacher } = this.props;
        teacher.isResetTeacherpassword = status;
        teacher.confirmationPassword = '';
        teacher.newPassword = '';
        teacher.adminPassword = '';
        if (this.state.isDirty && !status) {
            this.setState({ canSubmit: true });
        } else if (!this.state.isDirty && !status) {
            this.setState({ canSubmit: false });
        }
    }

    updateAdminPassword = (event) => {
        const { teacher } = this.props;
        teacher.adminPassword = event.target.value.trim();
        this.setState({ adminPassword: event.target.value.trim() });
    }

    callActionBasedonType = (type) => {
        switch (type) {
        case 'passwordReset': this.props.handleOnSendTeacherPassword();
            break;
        case 'verifyEmail': this.props.handleOnSendEmailVerificationLink();
            break;
        default: this.saveChanges();
            this.setState({ showAuthenticationModal: false });
            break;
        }
    }

    closeAuthentionModal = () => {
        this.setState({ showAuthenticationModal: false });
    }

    authentication = () => {
        this.callActionBasedonType('save');
    }

    enableSave = () => {
        if (this.state.canSubmit || this.props.enableSave) {
            return true;
        }

        return false;
    }

    render() {
        const sortedTitles = this.props.teacherTitles.slice(1).sort((a, b) => a.value.localeCompare(b.value));
        sortedTitles.unshift(this.props.teacherTitles[0]);
        const editTeacherView = this.props.isLoadingEditTeacherDetail === false
            ? (
                <div className={this.props.css.editTeacher}>
                    <div
                        className={this.props.css.teacherName}>{this.props.teacher.title} {this.props.teacher.firstName} {this.props.teacher.lastName}</div>
                    <div className={this.props.css.teacherDetails}>
                        <TeacherDetail
                            editTeacherValidationMessage={this.props.editTeacherValidationMessage}
                            handleEmailInputOnChange={this.handleEmailInputOnChange}
                            handleOnCloseValidationModal={this.handleOnCloseValidationModal}
                            handleOnListChange={this.handleListOnChange}
                            handleOnPasswordInputChange={this.handleOnPasswordInputChange}
                            handleOnPrintSignInCard={this.props.handleOnPrintSignInCard}
                            handleOnSendTeacherPassword={this.callActionBasedonType}
                            handleOnTextInputChange={this.handleTextInputOnChange}
                            isSignInCardDownloaded={this.props.isSignInCardDownloaded}
                            resetPassword={this.resetPassword}
                            teacher={this.props.teacher}
                            teacherTitles={sortedTitles}
                        />
                    </div>
                    <div className={this.props.css.classDetails}>
                        <TeacherClassDetail
                            downloadingClassroomIds={this.props.downloadingClassroomIds}
                            editTeacherDetail={this.props.editTeacherDetail}
                            handleOnAssignClass={this.props.handleOnAssignClass}
                            handleOnCancelStudentSignInCards={this.props.handleOnCancelStudentSignInCards}
                            handleOnCloseModal={this.props.handleOnCloseModal}
                            handleOnPrintClassroomSignInCard={this.props.handleOnPrintClassroomSignInCard}
                            handleOnStudentSignInCards={this.props.handleOnStudentSignInCards}
                            handleOnUnassignConfirm={this.props.handleOnUnassignConfirm}
                            handleOnUnassignTeacher={this.props.handleOnUnassignTeacher}
                            isLoading={this.props.isLoading}
                            isUnassignedModalOpen={this.props.isUnassignedModalOpen}
                            productName={this.props.productName}
                            showHideSignInCardModal={this.props.showHideSignInCardModal}
                            showUnassignTeacherModal={this.props.showUnassignTeacherModal}
                            unassignTeachersSuccessConfirmation={this.props.unassignTeachersSuccessConfirmation}
                        />
                    </div>
                    <div className={this.props.css.teacherFooter}>
                        <div className={this.props.css.buttonContainer}>
                            <Button
                                containerClassName={this.props.css.cancelButton}
                                disabled={this.props.updatingTeacher}
                                handleOnClick={this.props.closeEditTeacher}
                                label={this.props.intl.formatMessage((messages.cancel))}
                                variant={DARK} />
                            <Button
                                containerClassName={this.props.css.saveButton}
                                disabled={!this.enableSave()}
                                handleOnClick={this.handleOnSubmit}
                                label={this.props.intl.formatMessage(messages.save)}
                                variant={DARK} />
                        </div>
                    </div>
                    <Modal show={this.state.showAuthenticationModal}>
                        <Authentication
                            handleOnCancel={this.closeAuthentionModal}
                            handleOnContinue={this.authentication}
                            handleOnPasswordChange={this.updateAdminPassword}
                        />
                    </Modal>
                </div>
            )
            : (
                <div className={this.props.css.loader}>
                    <Loader color="grey" size="15px" />
                </div>
            );

        return editTeacherView;
    }
}

EditTeacherForm.propTypes = {
    teacherName: PropTypes.string,
    updatingTeacher: PropTypes.bool,
    css: PropTypes.object,
    teacher: PropTypes.object,
    teacherTitles: PropTypes.arrayOf(PropTypes.object),
    handleOnEditTeacherSubmit: PropTypes.func,
    editTeacherValidationMessage: PropTypes.string,
    closeEditTeacherValidationModal: PropTypes.func,
    closeEditTeacher: PropTypes.func,
    handleOnPrintSignInCard: PropTypes.func,
    isSignInCardDownloaded: PropTypes.bool,
    productName: PropTypes.string,
    editTeacherDetail: PropTypes.object,
    handleOnUnassignTeacher: PropTypes.func,
    handleOnCloseModal: PropTypes.func,
    handleOnUnassignConfirm: PropTypes.func,
    unassignTeachersSuccessConfirmation: PropTypes.func,
    isUnassignedModalOpen: PropTypes.bool,
    showUnassignTeacherModal: PropTypes.bool,
    isLoading: PropTypes.bool,
    isLoadingEditTeacherDetail: PropTypes.bool,
    handleOnPrintClassroomSignInCard: PropTypes.func,
    downloadingClassroomIds: PropTypes.object,
    intl: intlShape.isRequired,
    handleOnAssignClass: PropTypes.func,
    handleOnStudentSignInCards: PropTypes.func,
    handleOnCancelStudentSignInCards: PropTypes.func,
    showHideSignInCardModal: PropTypes.bool,
    showToast: PropTypes.func,
    handleOnSendTeacherPassword: PropTypes.func,
    handleOnSendEmailVerificationLink: PropTypes.func,
    enableSave: PropTypes.bool
};

export default (injectIntl(styleable(css)(EditTeacherForm)));



// WEBPACK FOOTER //
// ./app/components/edit-teacher-form/index.js